<template>
<div>
    <router-link v-if="$can('read', 'ipg-gateway')" :to="'psp-request/'+row.id+'/details'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-eye"></i>
    </router-link>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import { userService } from '@/common/api.service'
import toastr from 'toastr'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods : {
        deleteUser(e) {
            userService.delete(this.row.id).then(
                response => {
                    this.toastr.success(response.data.message)
                    this.row.is_deleted = true
                    // set status 3 to show user as a deleted
                    // just for showing
                    this.row.status = 3
                },
                error => {
                    //
                }
            )
        },
        restoreUser(e) {
            userService.restore(this.row.id).then(
                response => {
                    this.toastr.success(response.data.message)
                    this.row.is_deleted = false
                    this.row.status = 6
                    userService.find(this.row.id).then(
                        response => {
                            this.row.status = response.data.data.status
                        }
                    )
                },
                error => {
                    //
                }
            )
        }
    },
})
</script>